import { RootState } from '@app/redux/root-reducer';

export const selectBannerState = (store: RootState) => store.bannerReducer.banner;
export const selectAddBannerState = (store: RootState) => store.bannerReducer.addBanner;
export const selectUpdateBannerState = (store: RootState) => store.bannerReducer.bannerStatus;
export const selectDeleteBannerState = (store: RootState) => store.bannerReducer.deleteBanner;
